<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 10px;">
      <div class="ele-table-tool ele-table-tool-default">
        <div class="ele-table-tool-title">各宿舍楼考勤统计</div>
        <div class="ele-table-tool-right">
          <el-button type="primary" icon="el-icon-refresh" class="ele-btn-icon" size="small"
            @click="reload">刷新</el-button>
        </div>
      </div>

      <ele-data-table ref="table" :config="table" highlight-current-row height="calc(100vh - 200px)">
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="name" label="宿舍楼" align="center" show-overflow-tooltip min-width="140" />
          <el-table-column prop="inNum" label="在寝" align="center" show-overflow-tooltip min-width="100" />
          <el-table-column prop="outNum" label="不在寝室" align="center" show-overflow-tooltip min-width="100" />
          <el-table-column prop="leaveNum" label="请假" align="center" show-overflow-tooltip min-width="100" />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'TowerTotal',
  data () {
    return {
      table: {
        url: '/school/dormitory/attendanceStatistics',
        method: 'GET',
        page: false,
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          res.msg = res.resMsg;
          const data = res.data || {};
          res.data = Array.isArray(data) ? data : data.records || data.mlist || data.list || data.rows || [];
          return res;
        },
      },
    };
  },
  methods: {
    reload () {
      this.$refs.table.reload();
    },
  },
};
</script>

<style scoped></style>
